import { useController } from "react-hook-form";
import { components, type OptionProps } from "react-select";
import { Body } from "../../../../../../../Common/Typography";
import { OptionContainer } from "../../../../../../../Inputs/__styles__/MultiSelect";
import MultiSelect, {
  type BaseOption,
} from "../../../../../../../Inputs/MultiSelect";
import Select from "../../../../../../../Inputs/Select";
import {
  getUiSchemaPropertyFormPath,
  useBuilderWatch,
} from "../../../form/form";
import type { DropdownWidgetSettingsProps } from "./DropdownWidgetSettings";
import type { OneOfOptions } from "./types";
import { getSchemaOptionsPath } from "./utils";

type DropdownDefaultValueInputProps = DropdownWidgetSettingsProps;

export function DropdownStaticDefaultInput({
  fieldPath,
  isReadOnly,
  inputType,
}: DropdownDefaultValueInputProps) {
  const defaultValuePath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValue",
  );
  const { field } = useController({ name: defaultValuePath });

  const options: OneOfOptions = useBuilderWatch(
    getSchemaOptionsPath(fieldPath, inputType),
  );

  const formattedOptions =
    options?.map(option => {
      if (typeof option === "string") {
        return {
          label: option,
          value: option,
        };
      }

      return {
        label: option.title,
        value: option.const,
      };
    }) ?? [];

  if (inputType === "select") {
    return (
      <Select
        value={field.value}
        label="Static default value"
        name={defaultValuePath}
        options={formattedOptions}
        onChange={value => {
          // store no value (undefined) for ui:defaultValue instead of empty
          // string in form state
          field.onChange(value ?? undefined);
        }}
        disabled={isReadOnly}
        isClearable={true}
      />
    );
  }

  return (
    <MultiSelect
      value={field.value ?? []}
      label="Static default value"
      name={defaultValuePath}
      options={formattedOptions}
      onChange={value => {
        field.onChange(value ?? []);
      }}
      disabled={isReadOnly}
      renderOption={(
        option: BaseOption,
        props: OptionProps<BaseOption, true>,
      ) => (
        <components.Option {...props}>
          <OptionContainer>
            <Body size="large" type="regular">
              {option.label}
            </Body>
          </OptionContainer>
        </components.Option>
      )}
    />
  );
}
